module.exports = __webpack_public_path__ + "img/document-add-icon.b195040.svg";